export default "__VITE_ASSET__CPvQbLL4__"